import { getAppKey } from '@kurtosys/app-loader/dist/utils.js';
import { IAppResponse, IAppsHydration, IAppsResponse } from '@kurtosys/types/appsInitialize/index.js';
import { IManifest } from '@kurtosys/types/appsManager/index.js';

import { commonUtils, helpers } from '../common/index.js';

export class AppHydration {
	constructor(public hydrationKey: string) {}
	getAppHydration(manifest: IManifest, appParamsHelper: helpers.AppParamsHelper<any, any, any>): IAppResponse {
		const hydrationId = getAppKey(manifest, appParamsHelper);
		const hydrationPoint = this.getHydrationPoint();
		return hydrationPoint && hydrationPoint.appsByKey && hydrationPoint.appsByKey[hydrationId];
	}
	getManagerHydration(): IAppResponse | undefined {
		const hydrationPoint = this.getHydrationPoint();
		return hydrationPoint && hydrationPoint.manager;
	}
	mergeAppsResponses(appsResponses: IAppsResponse[]): IAppsResponse | undefined {
		const javascriptPieces = [];
		if (appsResponses && appsResponses.length > 0) {
			const merged: IAppsResponse = { apps: [] };
			const appsHash: Map<string, boolean> = new Map();
			const translationHash: Map<string, boolean> = new Map();
			for (const appsResponse of appsResponses) {
				const { apps, manager, translations, javascript } = appsResponse;
				if (manager && typeof manager === 'object' && Object.keys(manager).length > 0) {
					merged.manager = manager;
				}
				if (apps && merged.apps) {
					apps.forEach((app) => {
						const key = `${app.app.applicationCode}_${app.app.id}`;
						if (!appsHash.has(key)) {
							appsHash.set(key, true);
							merged.apps.push(app);
						}
					});
				}
				if (translations) {
					if (!merged.translations) {
						merged.translations = [];
					}
					translations.forEach((translation) => {
						const key = `${translation.phrase}_${translation.culture}_${translation.translationCulture}`;
						if (!translationHash.has(key)) {
							translationHash.set(key, true);
							merged.translations.push(translation);
						}
					});
				}
				if (javascript) {
					javascriptPieces.push(javascript);
				}
			}
			if (javascriptPieces && javascriptPieces.length > 0) {
				merged.javascript = javascriptPieces.join('\n');
			}
			return merged;
		}
		return;
	}
	setHydrationPoint(appsResponse: IAppsResponse): void {
		let hydrationPoint: IAppsHydration = this.getHydrationPoint();
		if (!hydrationPoint) {
			hydrationPoint = {
				appsByKey: {},
			};
		}
		const mergedAppsResponse = this.mergeAppsResponses([hydrationPoint, appsResponse]);
		hydrationPoint = {
			...mergedAppsResponse,
			appsByKey: {
				...commonUtils.pivotCollection(
					mergedAppsResponse.apps || [],
					(appResponse) => appResponse.app.id || 'NO_ID',
				),
				...commonUtils.pivotCollection(
					mergedAppsResponse.apps || [],
					(appResponse) => `${appResponse.app.id}|${appResponse.app.applicationCode}`,
				),
			},
		};
		(window as any)[this.hydrationKey] = hydrationPoint;
	}

	getHydrationPoint(): IAppsHydration {
		if (!(window as any)[this.hydrationKey]) {
			(window as any)[this.hydrationKey] = {};
		}
		return (window as any)[this.hydrationKey];
	}
}
